import { render, staticRenderFns } from "./CustomerDynamics.vue?vue&type=template&id=8033aef2"
import script from "./CustomerDynamics.vue?vue&type=script&lang=js"
export * from "./CustomerDynamics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports